import { SELECIONAR_PESSOA_DESTINATARIO } from '../types'

export default function selecionarPessoaDestinatario (pessoa) {
  return {
    type: SELECIONAR_PESSOA_DESTINATARIO,
    payload: pessoa
  }
}
